module.exports = __webpack_public_path__ + "img/coming-soon-dark.6a9c0f2b.svg";